// utils/addAdventureLog.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function addAdventureLog(logEntry) {
  try {
    await addDoc(collection(db, "adventureLogs"), {
      ...logEntry,
      createdAt: serverTimestamp(),
    });
    console.log("✅ Adventure log saved:", logEntry);
  } catch (error) {
    console.error("❌ Error saving adventure log:", error);
  }
}
